import GroupsAdministration from 'features/admin/groups/GroupsAdministration';

const GroupsAdministrationPage = () => <GroupsAdministration />;

export default GroupsAdministrationPage;
